import React from "react"
import { Divider, Grid } from "@mui/material"
import { DrawerSeeker } from "@ui-seeker/core"
import { autoEuropeSeasonSetsDrawerData, autoEuropeSeasonSetsIsSubmitting, isAutoEuropeSeasonSetsDrawerOpen } from "Pages/AutoEuropeTool/SeasonSets/@signals"
import AutoEuropeSeasonSetsFooter from "Pages/AutoEuropeTool/SeasonSets/@components/Footer"
import AutoEuropeSeasonSetsNameField from "Pages/AutoEuropeTool/SeasonSets/@components/NameField"
import AutoEuropeSeasonSetsRangesField from "Pages/AutoEuropeTool/SeasonSets/@components/SeasonRangesField"

export default function AutoEuropeSeasonSetsDrawer({ onSubmit }) {
	const isEditing = !!autoEuropeSeasonSetsDrawerData.peek().id

	return <DrawerSeeker
		title={isEditing ? autoEuropeSeasonSetsDrawerData.peek().name : "Create Season Set"}
		anchor="right"
		width="40%"
		variant="persistent"
		isOpen={isAutoEuropeSeasonSetsDrawerOpen.value}
		customFooter={
			<AutoEuropeSeasonSetsFooter
				onSubmit={() => onSubmit(autoEuropeSeasonSetsDrawerData.peek())}
				isLoading={autoEuropeSeasonSetsIsSubmitting.value}
			/>
		}
	>
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<AutoEuropeSeasonSetsNameField/>
			</Grid>
			<Grid item xs={12}><Divider/></Grid>
			<Grid item xs={12}>
				<AutoEuropeSeasonSetsRangesField/>
			</Grid>
		</Grid>
	</DrawerSeeker>
}
